import React from 'react';
import { useSubscriptionGuard } from '../hooks/useSubscriptionGuard';

interface SubscriptionProtectedRouteProps {
  children: React.ReactNode;
}

export function SubscriptionProtectedRoute({ children }: SubscriptionProtectedRouteProps) {
  useSubscriptionGuard();

  return <>{children}</>;
}
